// extracted by mini-css-extract-plugin
module.exports = {"nav-link-icon":"_2h-bsI7K mr1","navLinkIcon":"_2h-bsI7K mr1"};